import { Button, Modal, Radio, RadioChangeEvent } from 'antd';
import { MeetingType } from 'commons/types/meetingsTypes';
import { useCallback, useState } from 'react';
import { useAppDispatch } from 'stores/hooks';
import { deleteMeetingAsync } from 'stores/meetings/meetingsSlice';

const REASONS: Record<MeetingType, string[]> = {
  None: ['Autre'],
  RDV_1: [
    "Je n'ai pas de symptômes majeurs necessitant de me faire diagnostiquer",
    'Je veux me faire diagnostiquer mais je souhaite faire le parcours médical ailleurs',
    'Autre',
  ],
  RDV_2: [
    "J'ai des symptômes d'apnée du sommeil (fatigue, ronflements) mais je souhaite faire le parcours médical ailleurs",
    "Je n'ai pas de symptômes majeurs necessitant de me faire diagnostiquer",
    "J'ai des symptômes mais je ne veux pas faire de diagnostic à cause de la contrainte logistique.",
    "J'ai des symptômes mais je ne veux pas faire de diagnostic à cause du prix.",
    'Autre',
  ],
  RDV_3: [
    'Je souhaite obtenir mes résultats par email, et non par vidéo-consultation',
    'Je suis indisponible sur tous les créneaux proposés.',
    'Autre',
  ],
  RDV_PPC: [
    'Je souhaite obtenir mes résultats par email, et non par vidéo-consultation',
    'Je suis indisponible sur tous les créneaux proposés.',
    'Autre',
  ],
  RDV_SWITCH: [
    "Je n'ai pas de symptômes majeurs necessitant de me faire diagnostiquer",
    'Je veux me faire diagnostiquer mais je souhaite faire le parcours médical ailleurs',
    'Autre',
  ],
};
export default function DeleteScheduleModal({
  type,
  meetingID,
}: {
  type: MeetingType;
  meetingID: string;
}) {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const showModal = useCallback(() => setOpen(true), []);
  const hideModal = useCallback(() => setOpen(false), []);
  const deleteAction = useCallback(() => {
    dispatch(deleteMeetingAsync({ id: meetingID, reason }));
    setOpen(false);
  }, [dispatch, meetingID, reason]);
  const onClickReason = useCallback(
    (e: RadioChangeEvent) => setReason(e.target.value),
    [],
  );

  return (
    <div className='text-center'>
      <Button
        className='my-4 !rounded-[32px] !h-14'
        onClick={showModal}
        danger
      >
        Annuler mon rendez-vous
      </Button>
      <Modal
        open={open}
        footer={null}
        closable={false}
        onCancel={hideModal}
      >
        <div className='flex flex-col text-center'>
          <h2 className='text-base font-semibold mb-0'>
            Etes vous certain de vouloir annuler votre rendez-vous ?
          </h2>
          <p className='text-sm my-4'>
            Il se peut qu’il soit compliqué de retrouver un praticien disponible
          </p>
          <p className='text-xs font-semibold mt-4 mb-4 mx-4'>
            Pouvez nous aider à comprendre les raison de votre annulation
          </p>
          <Radio.Group
            onChange={onClickReason}
            className='!flex !flex-col items-center !px-4 space-y-2'
            defaultValue={REASONS[type][0]}
          >
            {REASONS[type].map((r: string, index: number) => (
              <Radio
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                value={r}
                className='w-full text-left'
              >
                {r}
              </Radio>
            ))}
          </Radio.Group>
          <Button
            danger
            className='!rounded-[32px] !h-10 mt-8'
            onClick={deleteAction}
          >
            Confirmer l’annulation
          </Button>
          <Button
            className='my-4 !rounded-[32px] !h-10'
            onClick={hideModal}
            type='link'
          >
            Conserver le rendez-vous
          </Button>
        </div>
      </Modal>
    </div>
  );
}
